import React from 'react'
import { useTranslation } from 'react-i18next'
import Button from '../../../../components/Button'
import Text from '../../../../components/Text'
import cx from 'classnames'
import styles from './DeleteFulfillmentModal.module.css'
import { useDeleteData } from '../../../../hooks/useDeleteData'
import { ApiRoutes } from '../../../../services/ApiService'
import { closeModal } from '../../../../services/ModalService'
import { showToast } from '../../../../services/ToastService'
import { Fulfiller } from '../../../../types/Fulfiller'

type DeleteFulfillmentModalProps = {
    fulfiller: Fulfiller
    onSubmit: () => void
}

const DeleteFulfillmentModal: React.FC<DeleteFulfillmentModalProps> = ({
    fulfiller,
    onSubmit,
}) => {
    const { t } = useTranslation(['settings'])
    const { submit } = useDeleteData(ApiRoutes.FULFILLER, fulfiller.id)

    const handleSubmit = () => {
        submit()
            .then((res) => {
                if (res.status < 300) {
                    showToast(t('fulfillment.delete_modal.success'))
                    onSubmit()
                    closeModal()
                } else {
                    showToast(t('fulfillment.delete_modal.error'), 'error')
                    closeModal()
                }
            })
            .catch(() => {
                showToast(t('fulfillment.delete_modal.error'), 'error')
                closeModal()
            })
    }

    return (
        <div className={cx(styles['modal-wrapper'])}>
            <Text>
                {t('fulfillment.delete_modal.sub_heading', {
                    email: fulfiller.email,
                })}
            </Text>
            <Button
                hierarchy={'primary'}
                text={t('fulfillment.delete_modal.delete')}
                fn={() => handleSubmit()}
                classes={'zr-w-100 zr-mx-4 zr-my-2'}
            />
            <Button
                hierarchy={'secondary'}
                text={t('common.abort')}
                fn={() => closeModal()}
                classes={'zr-w-100 zr-mx-4 zr-my-2'}
            />
        </div>
    )
}

export default DeleteFulfillmentModal
